import React, { useEffect, useRef } from 'react';
import { SlTooltip } from '@shoelace-style/shoelace/dist/react';
import ActionButton from './ActionButton';
import { ACTION_CONFIGS } from '../utils/actionHandlers';
import more from "../../../assets/svg/more.svg"
import { useChatContext } from '../../../context/ChatContext';

const ActionsMenu = ({
    rowIndex,
    row,
    showActionsMenu,
    actionHandlers,
    expandedVersionsRow
}) => {
    const isMenuOpen = showActionsMenu === rowIndex;
    const menuRef = useRef(null);
    const { openChat } = useChatContext();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isMenuOpen &&
                menuRef.current &&
                !menuRef.current.contains(event.target)
            ) {
                actionHandlers.toggleActionsMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen, actionHandlers]);
    
    return (
        <div className="flex justify-center relative" ref={menuRef}>
            <SlTooltip content={isMenuOpen ? 'Close Actions' : 'More Actions'} hoist>
                <div
                    onClick={() => actionHandlers.toggleActionsMenu(rowIndex, showActionsMenu)}
                    className="bg-transparent cursor-pointer"
                >
                    <img
                        src={more}
                        alt="More"
                        className={`w-5 h-5 ${isMenuOpen ? 'rotate-90' : ''}`}
                    />
                </div>
            </SlTooltip>

            {isMenuOpen && (
                <div
                    className="absolute z-10 top-0 right-full py-2 px-3 flex gap-3 items-center bg-gray-600 border border-gray-300 shadow-lg rounded-md space-x-2 w-48"
                    style={{ transform: 'translateY(-25%)' }}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    {ACTION_CONFIGS.map((config) => (
                        <ActionButton
                            key={config.key}
                            icon={config.icon}
                            alt={config.alt}
                            tooltip={config.tooltip}
                            onClick={() => {
                                if (config.key === 'openChat') {
                                    openChat(row);
                                } else if (config.key === 'toggleVersions') {
                                    actionHandlers[config.key](rowIndex, expandedVersionsRow);
                                } else {
                                    actionHandlers[config.key](row);
                                }
                                actionHandlers.toggleActionsMenu(null);
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ActionsMenu;
